import { CampaignWorkflowFormAction } from './CampaignWorkflowFormState';

export type FormKeys = 'trigger' | 'emailAllowList' | 'branchControl';
export const CampaignWorkflowFormActions = dispatch => ({
  setFocused: (key: FormKeys | string, isFocused: boolean): CampaignWorkflowFormAction =>
    dispatch({
      type: 'SET_FOCUSED',
      payload: { key, isFocused },
    }),
  setErrors: (errors: { [key: string]: boolean }) =>
    dispatch({
      type: 'SET_ERRORS',
      payload: { errors },
    }),
  setTouched: (key: FormKeys | string, isTouched: boolean): CampaignWorkflowFormAction =>
    dispatch({
      type: 'SET_TOUCHED',
      payload: { key, isTouched },
    }),
  setValidationResults: (results: { error: string }[], validationType?: 'save' | 'test'): CampaignWorkflowFormAction =>
    dispatch({
      type: 'SET_VALIDATION_RESULTS',
      payload: results,
      validationType,
    }),
});
